// extracted by mini-css-extract-plugin
module.exports = {"legal":"Ios_legal__ghPh_"};